import React from "react";
import PropTypes from "prop-types";
import ChevronIcon from "../../atoms/icons/ChevronIcon";

export default function SidebarSectionHeader({
    title,
    isOpen,
    onToggle,
    action,
    ariaLabel,
    className,
    variant = "bar",
    contentId,
}) {
    const sectionClassName = `band-sidebar__section-header${variant === "bar" ? " band-sidebar__section-header--bar" : ""}${className ? ` ${className}` : ""}`;
    const handleToggle = () => {
        if (onToggle) {
            onToggle();
        }
    };

    return (
        <div className={sectionClassName}>
            <button
                type="button"
                className={`band-sidebar__header-toggle${variant === "bar" ? " band-sidebar__header-toggle--bar" : ""}`}
                aria-label={ariaLabel || `Toggle ${title.toLowerCase()}`}
                aria-expanded={Boolean(isOpen)}
                {...(contentId ? { "aria-controls": contentId } : {})}
                onClick={handleToggle}
            >
                <span className="band-sidebar__chevron" aria-hidden="true">
                    <ChevronIcon size={14} direction={isOpen ? "down" : "right"} className="band-sidebar__chevron-icon" />
                </span>
                <h2 className="band-sidebar__section-title">{title}</h2>
            </button>
            {action}
        </div>
    );
}

SidebarSectionHeader.propTypes = {
    title: PropTypes.string.isRequired,
    isOpen: PropTypes.bool,
    onToggle: PropTypes.func,
    action: PropTypes.node,
    ariaLabel: PropTypes.string,
    className: PropTypes.string,
    variant: PropTypes.oneOf(["bar", "plain"]),
    contentId: PropTypes.string,
};
